import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './styles.css';

const DownloadButton = ({ fileName, timestamp = 'Gerado agora', onClickDownload }) => {
  const { t } = useTranslation();
  const [isDownloading, setIsDownloading] = useState(false);
  
  //   console.log('DownloadButton renderizado com:', { fileName, timestamp, onClickDownload: typeof onClickDownload });

  const formatFileSize = (sizeInBytes) => {
    if (!sizeInBytes) return '';
    const mb = sizeInBytes / (1024 * 1024);
    return `${mb.toFixed(1)} Mb`;
  };

  const handleDownload = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!onClickDownload || isDownloading) return;
    setIsDownloading(true);
    try {
      await onClickDownload();
    } catch (err) {
      console.error('Erro ao baixar documento:', err);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <button
      type="button"
      className="download-button-container"
      disabled={isDownloading}
      onClick={handleDownload}
    >
      <div className="download-button-icon-wrapper">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="download-button-file-icon"
        >
          <path
            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
            stroke="#FF5D5D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14 2V8H20"
            stroke="#FF5D5D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <div className="download-button-content">
        <p className="download-button-filename">{fileName}</p>
        <p className="download-button-info">
          {timestamp && ` • ${timestamp}`}
        </p>
      </div>

      <span
        className="download-button-action"
        aria-label={t('chatsocket.download_button.aria_label')}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 10L12 15L17 10"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 15V3"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  );
};

export default DownloadButton;
export {DownloadButton as StrategyDownloader};
